export default __webpack_public_path__ + "static/media/check.11fbf349.svg";